import { api } from '@/api';
import { PaginatedBody, PaginationSearchParams } from '@/api/types';
import { getProvidersByIds } from '../partner-providers';
import { BannedTailNumber } from '@/api/apis/resources';

export const getBannedTailNumbersListWithProvider = async (
  pagination: PaginationSearchParams,
): Promise<PaginatedBody<BannedTailNumber>> => {
  const data = await api.resource.getBannedTailNumbersList(pagination);

  if (data) {
    const providersIds = data.items.map((c) => c.logisticProviderId ?? '');
    const providers = await getProvidersByIds(providersIds);

    if (providers) {
      return {
        ...data,
        items: data.items.map((c) => ({
          ...c,
          logisticProvider: providers.items.find((e) => e.id === c.logisticProviderId),
        })),
      };
    }
  }

  return data;
};

export const getBannedTailNumberIdWithProvider = async (id: string): Promise<BannedTailNumber> => {
  const data = await api.resource.getBannedTailNumbersById(id);

  if (data) {
    const providersId = data.logisticProviderId ?? '';
    const provider = await api.partnerprovider.getPartnerProvidersById(providersId);

    if (provider) {
      return {
        ...data,
        logisticProvider: provider,
      };
    }
  }

  return data;
};
